// This file is autogenerated. Any changes will be overwritten.

export const set = 'streamline';

export const name = 'paper-clip';

export const Component = () => (
  <path
    fill='none'
    stroke='currentColor'
    strokeLinecap='round'
    strokeLinejoin='round'
    d='m17.438 7.425-8.233 8.234a5.063 5.063 0 1 1-7.16-7.16l6.762-6.761A3.375 3.375 0 1 1 13.58 6.51l-6.762 6.765a1.688 1.688 0 0 1-2.386-2.386l6.762-6.764'
  />
);

export const viewBox = '0 0 18 18';
